import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { user } from "../services/api";

// Thunk to fetch vendors data
export const fetchUsers = createAsyncThunk(
    "users/fetchUsers",
    async () => {
        const response = await user();
        return response;
    }
);

const usersSlice = createSlice({
    name: "users",
    initialState: {
        data: [],
        status: "idle",
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchUsers.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchUsers.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.data = action.payload;
            })
            .addCase(fetchUsers.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });
    },
});

export default usersSlice.reducer;

